import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Modal, Button, Form, Tab, Message, Confirm, Header, Divider, Accordion, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import GuestSearchDropDown from "../shared/GuestSearchDropDown";
import RoomTypesDropDown from "../shared/RoomTypesDropDown";
import RoomsDropDown from "../shared/RoomsDropDown";
import CustomerDropDown from "../shared/CustomerDropDown";
import ProductsDropDown from "../shared/ProductsDropDown";
import ReservationSourcesDropDown from "../shared/ReservationSourcesDropDown";
import { onSuccess, onError, onWarning } from "../shared/messages";
import {
  SaveReservation,
  CalculateTotalAmountCurrentReservation,
} from '../../api/services/pms';
import { endpoint } from '../../api/http';
import { AllocationAndStrategy, Addons, HotelDefaultReservationValues, Rates, Products, Hotels, Promotions, ReservationPolicy as ReservationPolicyAPI, Calendar } from '../../api/services/next';
import PricingTypesDropDown from '../shared/PricingTypesDropdown';
import formatCurrency from 'format-currency';
import { Currencies } from '../shared/currencies';
import _ from 'lodash';
import { useMessageResources, useTextResources } from '../../language';
import { DatePicker, TimePicker } from '../shared/DatePicker';
import moment from 'moment';
import CurrencyInput from '../shared/CurrencyInput';
import NumericInput from '../shared/NumericInput';
import { GetHotelParameters } from '../../api/services/organization';
import { GetCustomers, GetGuests } from '../../api/services/crm';
import {
  RebuildReservation,
  CleanReservationProps,
  RecalcReservationForFixedPricesPaxChange,
  GetSingleReservation,
} from '../shared/reservation';;
import { checkEmailValid, calculateAccomodationTaxes, hasDigitalCertificate } from '../shared/utils';
import { HtmlEditor } from '../shared/HtmlEditor';
import NationalitiesDropDown from '../shared/NationalitiesDropDown';
import HotelsDropDown from '../shared/HotelsDropDown';
import { isMobileOnly } from 'mobile-device-detect';
import { useLoader } from "../../hooks/useLoader";
import './styles.css';
import {
  PermissionsActions,
  UserHasPermission,
} from "../shared/permissionsActions";
import {
  ReservationAmountOverrideType,
  HotelFeatureCodes,
  dateFormat,
  EntityType
} from "../shared/constants";
import { ReservationStatusesEnums } from "../shared/statustypes";
import { PaymentDialog } from "../Payment/paymentDialog";
import saveAs from "file-saver";
import ClubMemberIcon from "../shared/ClubMemberIcon"
import { Guests } from "../../api/services/next";
import DropDown from '../shared/dropdown';
import { Clubs } from "../../api/services/next";
import { defaultAllowedPaymentProviderIDs } from '../Payment/paymentCommon';
import ExtraAddonsGrid from '../ExtraAddonsPopup/ExtraAddonsGrid';
import TextList from '../shared/TextList';
import { buildAutoDescriptionForPolicy } from '../shared/reservationPolicy';
import ReservationPolicyUpdateConfirmationPopup from '../ReservationPolicyUpdateConfirmationPopup';
import { useCurrentHotel } from "../../hooks/useCurrentHotel";
const ShortReservationPopup = ({
  onClose,
  reservation: initialReservation,
  onSave,
  hotel: propHotel,
  ...rest
}) => {
  const text = useTextResources();
  const message = useMessageResources();
  const loader = useLoader();
  const [reservation, setReservation] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [businessDate, setBusinessDate] = useState(new Date());
  const [agent, setAgentItem] = useState(null);
  const [company, setCompanyItem] = useState(null);
  const [guest, setGuestObj] = useState(null);
  const [confirmNewGuestElement, setConfirmNewGuestElement] = useState(null);
  const paymentDialogRef = useRef();
  const [defaults, setDefaults] = useState();
  const [hotelParams, setHotelParams] = useState([]);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [availableAllocations, setAvailableAllocations] = useState([]);
  // Tri-state: null = no allocation ever set, 0 = user explicitly cleared, number = selected allocation ID
  const [allocation, setAllocation] = useState(null);
  const [rateId, setRateId] = useState(null);
  const [promotionId, setPromotionId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState()
  const [clubMemberDetails, setClubMemberDetails] = useState();
  const [clubMemeberFeature, setClubMemberFeature] = useState(false);
  const [allocationFeature, setAllocationFeature] = useState(false);
  const [clubMemberPopup, setclubMemberPopup] = useState(null);
  const [displaySave, setDisplaySave] = useState(true);
  const [digitalPermissions, setDigitalPermissions] = useState(false);
  const [reservationDailyAddonsForDeletion, setReservationDailyAddonsForDeletion] = useState([])
  const [hotelAddons, setHotelAddons] = useState([])
  const [showPolicyChangePopup, setShowPolicyChangePopup] = useState(false);
  const [newPolicyDetails, setNewPolicyDetails] = useState(null);
  const [showRoomLockConfirm, setShowRoomLockConfirm] = useState(false);
  const [showRoomUnlockConfirm, setShowRoomUnlockConfirm] = useState(false);
  const [fetchedHotel, setFetchedHotel] = useState(null);
  const currentHotel = useCurrentHotel();
  const reservationHotel = propHotel || fetchedHotel;
  const [promoPolicy, setPromoPolicy] = useState(null);
  const currentProductKeyRef = useRef(null);
  const initialProductRef = useRef(null);
  const userChangedAllocationRef = useRef(false);
  const currentAllocationRef = useRef(undefined); // undefined = not resolved yet, null = no allocation, 0 = user explicitly cleared, number = selected allocation id
  const warnedInvalidSavedAllocationRef = useRef(false); // Track if we've warned about invalid saved allocation
  const [reservationLoaded, setReservationLoaded] = useState(false);
  const [insufficientAddon, setInsufficientAddon] = useState(false);
  const hotelid = initialReservation?.HotelId || reservation?.HotelId;
  const defaultNationalityId = useMemo(
    () =>
      hotelParams?.CurrentHotel?.[0]?.HotelParameter?.DefaultGuestNationalityID,
    [hotelParams]
  );

  useEffect(() => {
    setBusinessDate(new Date());
    setDisplaySave(true);

    const hotelFeatures = reservationHotel?.HotelFeatures;

    const hasClubMember = hotelFeatures?.find(
      (x) => x.FeatureId === HotelFeatureCodes.ClubMember
    );
    setClubMemberFeature(!!hasClubMember);

    const hasAllocation = hotelFeatures?.find(
      (x) => x.FeatureId === HotelFeatureCodes.Allocations
    );
    setAllocationFeature(!!hasAllocation);

    (async () => {
      const hasDigitalPermissions = await hasDigitalCertificate();
      setDigitalPermissions(hasDigitalPermissions)
    })();
  }, [reservationHotel]);

  // Fetch hotel from API if not provided via prop (if opened from homepage)
  useEffect(() => {
    if (!propHotel && hotelid) {
      (async () => {
        try {
          const hotels = await Hotels.GetHotels({ Id: hotelid, Includes: ['HotelFeatures'] });
          if (hotels?.length) {
            setFetchedHotel(hotels[0]);
          }
        } catch (err) {
          console.error('Failed to fetch hotel:', err);
        }
      })();
    }
  }, [propHotel, hotelid]);

  useEffect(() => {
    setDisplaySave(true);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const hotelAddons = await Addons.GetHotelAddons({
          IgnoreInventoryFilter: true,
          Includes: [
            "ChainAddon"
          ]
        })
        setHotelAddons(hotelAddons)
      }
      catch (err) {
        onWarning(err)
      }
    })()
  }, [])

  // Track when popup opens to force data refresh
  const isOpen = rest.open;

  useEffect(() => {
    // Only run when popup is open and we have reservation data
    if (!isOpen || _.isEmpty(initialReservation)) return;

    initialLoadRef.current = true;
    prevPaxRef.current = { Adults: null, Children: null, Infants: null };

    if (!initialReservation.Id) {
      initializeReservation();
    } else {
      (async () => {
        try {
          loader(true);
          // Fetch fresh reservation data from server to avoid stale data from another browser tab
          const freshReservations = await Calendar.GetReservations({
            Id: initialReservation.Id,
            HotelId: initialReservation.HotelId,
            includes: [
              'Room',
              'Status',
              'RoomType',
              'ReservationDailyAccommodations',
              'ReservationDailyAddons',
              'Product'
            ]
          });
          const freshReservation = freshReservations?.length ? freshReservations[0] : initialReservation;

          setAgentItem(freshReservation.Agent);
          setCompanyItem(freshReservation.Company);
          setGuestItem(freshReservation.Guest);

          // Fetch the actual saved totals from the database (includes manual price overrides)
          var totals = await CalculateTotalAmountCurrentReservation({
            Reservation: {
              ...freshReservation,
              Guest: null,
              ReservationDailyAccommodations: [],
              ReservationDailyAddons: reservation.ReservationDailyAddons
                ? reservation.ReservationDailyAddons.filter((x) => !x.ProductId)
                : null,
              IsDayUse: moment(freshReservation.CheckInDate).isSame(
                freshReservation.CheckOutDate,
                "day"
              ),
              RefetchReservation: true,
            },
            IsReCalculateTax: true,
            IncludeCommissionCalculation: freshReservation.Id ? true : false,
            DigitsPercision: 8,
          })
          if (freshReservation.Product) {
            // Ensure ProductKey is set for the dropdown to match
            const product = {
              ...freshReservation.Product,
              ProductKey: freshReservation.ProductId + '-' + (freshReservation.PromotionId || '')
            };
            initialProductRef.current = product;
            setSelectedProduct(product);
            if (product.RateId) {
              setRateId(product.RateId);
            }
            currentProductKeyRef.current = product.ProductKey;
          }
          else if (freshReservation.ProductId && !selectedProduct &&
            freshReservation.CheckInDate && freshReservation.CheckOutDate) {
            var products = await Products.Search({
              Id: freshReservation.ProductId,
              PromotionIds: freshReservation.PromotionId ? [freshReservation.PromotionId] : [],
              FromDate: moment(freshReservation.CheckInDate).toISOString(),
              ToDate: moment(freshReservation.CheckOutDate).toISOString(),
              Includes: [
                "ProductPrices",
                "DailyProductPrices",
              ]
            });
            if (products?.length) {
              // Ensure ProductKey is set for the dropdown to match
              const product = {
                ...products[0],
                ProductKey: products[0].Id + '-' + (products[0].PromotionId || '')
              };
              initialProductRef.current = product;
              setSelectedProduct(product);
              if (product.RateId) {
                setRateId(product.RateId);
              }
              currentProductKeyRef.current = product.ProductKey;
            }
          }

          if (freshReservation.ProductId && !freshReservation.RateId) {
            var rates = await Rates.GetRates({ ProductIds: [freshReservation.ProductId] });

            if (rates?.length) {
              setRateId(rates[0].Id);
            }
          }

          setReservation({
            ...freshReservation,
            CheckInDate: moment(freshReservation.CheckInDate)
              .startOf("day")
              .toDate(),
            CheckOutDate: moment(freshReservation.CheckOutDate)
              .startOf("day")
              .toDate(),
            // Use the actual saved totals from the database
            TotalAmountProductCurrentBeforeTax: totals?.TotalAmountProductCurrentBeforeTax,
            TotalAmountProductCurrentAfterTax: totals?.TotalAmountProductCurrentAfterTax,
            TotalAmountProductAddonsAfterTax: totals?.TotalAmountAddonsFromProductAfterTax,
            TotalAmountProductAddonsBeforeTax: totals?.TotalAmountAddonsFromProductBeforeTax,
          });

          setDiscountPercent(freshReservation.DiscountByPercent || 0);

          if (allocationFeature) {
            const reservationAllocationEntities = await AllocationAndStrategy.GetAllocationEntities({
              EntityIds: [initialReservation.Id],
              EntityTypeIds: [EntityType.Reservation]
            });
            if (reservationAllocationEntities.length) {
              const loadedId = reservationAllocationEntities[0].AllocationId;
              currentAllocationRef.current = loadedId;
              setAllocation(loadedId);
            } else {
              // null = no allocation was ever set for this reservation
              currentAllocationRef.current = null;
              setAllocation(null);
            }
            userChangedAllocationRef.current = false;
            warnedInvalidSavedAllocationRef.current = false;
          }

          setReservationLoaded(true);
        } catch (error) {
          onError(error);
        }
        finally {
          loader(false);
        }
      })()
    }
  }, [initialReservation, isOpen]);

  // Track previous pax values to detect changes
  const prevPaxRef = useRef({ Adults: null, Children: null, Infants: null });
  // Track if this is the initial load of an existing reservation to prevent false PAX change detection
  const initialLoadRef = useRef(true);
  // Track if PAX change came from user interaction (not code setting default values)
  const userChangedPaxRef = useRef(false);

  useEffect(() => {
    if (_.isEmpty(reservation)) return;

    // Skip PAX change detection on initial load of existing reservation
    // This prevents clearing the product when the popup first opens
    const isInitialLoad = initialLoadRef.current && reservation.Id;
    if (isInitialLoad) {
      // Mark initial load as complete after first render with data
      initialLoadRef.current = false;
      // Update prevPaxRef with initial values but don't trigger PAX change logic
      prevPaxRef.current = {
        Adults: reservation.Adults,
        Children: reservation.Children,
        Infants: reservation.Infants
      };
      return;
    }

    // Check if pax has changed (not on initial load)
    const paxChanged = prevPaxRef.current.Adults !== null && (
      prevPaxRef.current.Adults !== reservation.Adults ||
      prevPaxRef.current.Children !== reservation.Children ||
      prevPaxRef.current.Infants !== reservation.Infants
    );

    // Update previous pax values
    prevPaxRef.current = {
      Adults: reservation.Adults,
      Children: reservation.Children,
      Infants: reservation.Infants
    };

    // If pax changed from user interaction, clear the selected product so the dropdown re-fetches
    // This fixes the bug where products remain visible after pax exceeds MaxPax
    // Only trigger when userChangedPaxRef is true (set by PAX input onChange handlers)
    if (paxChanged && selectedProduct && userChangedPaxRef.current) {
      userChangedPaxRef.current = false; // Reset the flag
      setSelectedProduct(null);
      setRateId(null);
      setPromotionId(null);
      setReservation((prev) => ({
        ...prev,
        ProductId: null,
        PromotionId: null,
        TotalAmountProductCurrentBeforeTax: null,
        TotalAmountProductCurrentAfterTax: null,
        ReservationDailyAccommodations: [],
        // Only keep extra addons (ones without ProductId)
        ReservationDailyAddons: prev.ReservationDailyAddons?.filter(addon => !addon.ProductId) || []
      }));
      setDiscountPercent(0);
      return;
    }

    if (
      !reservation.Id &&
      reservation.RoomTypeId &&
      reservation.ProductId &&
      reservation.CheckInDate &&
      reservation.CheckOutDate
    ) {
      const updated = {
        ...reservation,
        DiscountByPercent: 0
      }
      setReservation(updated)
      setDiscountPercent(0)
    } else if (!reservation.RoomTypeId || !reservation.ProductId || !reservation.CheckInDate || !reservation.CheckOutDate) {
      setReservation((prev) => {
        return {
          ...prev,
          TotalAmountProductCurrentBeforeTax: null,
          TotalAmountProductCurrentAfterTax: null,
        };
      });
    }
  }, [
    reservation.HotelId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.RoomTypeId,
    reservation.CheckInDate,
    reservation.CheckOutDate,
    reservation.ProductId,
    reservation.ReservationPricingTypeId,
  ]);

  useEffect(() => {
    // For existing reservations, wait until load is complete (including GetAllocationEntities)
    if (allocationFeature && !isSaving && (reservationLoaded || !initialReservation?.Id)) {
      (async () => {
        try {
          loader(true);

          if (mandatoryAllocationFieldsSupplied()) {
            // Determine the "current" allocation: prefer the originally-loaded value from the DB,
            // fall back to the user's manual selection if the load hasn't happened yet.
            const currentAllocation = currentAllocationRef.current !== undefined
              ? currentAllocationRef.current
              : (userChangedAllocationRef.current ? allocation : null);

            // Always send the originally-loaded allocation ID to the backend so it's included
            // in results even when it has 0 available rooms.
            // Use nullish check so that allocation value of 0 (explicit unlink) is not treated as falsy.
            const persistentAllocationId = (currentAllocationRef.current !== null && currentAllocationRef.current !== undefined)
              ? currentAllocationRef.current
              : currentAllocation;

            const allocations = await AllocationAndStrategy.GetAvailableAllocations({
              RateIds: [rateId],
              PromotionIds: selectedProduct?.PromotionId ? [selectedProduct.PromotionId] : [],
              CustomerIds: [agent?.Id, company?.Id].filter(Boolean),
              RoomTypeIds: [reservation.RoomTypeId],
              MinimumAvailableRooms: reservation.Quantity || 1,
              GetFirstDayOfEachAllocation: true,
              HotelId: reservation.HotelId,
              FromDate: moment(reservation.CheckInDate).startOf('day').toISOString(),
              ToDate: moment(reservation.CheckOutDate).startOf('day').toISOString(),
              CurrentAllocationId: persistentAllocationId || undefined
            });

            setAvailableAllocations(allocations);

            // If current allocation is still in results — keep it
            if (currentAllocation && allocations.find(a => a.AllocationId === currentAllocation)) {
              // Ensure state is in sync with the ref value (handles initial load race)
              setAllocation(currentAllocation);
            }
            // If current allocation is no longer valid — warn and set to null (auto-removed).
            // null means "automatically removed due to spec change" — eligible for auto-select if spec changes back.
            // The server will receive 0 (handled at save time via `allocation || 0`) to remove the allocation entity.
            if (currentAllocation && !allocations.find(a => a.AllocationId === currentAllocation)) {
              onWarning(message("SelectedAllocationDoesntMatchReservation"));
              currentAllocationRef.current = null;
              setAllocation(null);
              userChangedAllocationRef.current = false;
            }
            // allocation is null (never selected) — auto-select first available
            // allocation is 0 (user explicitly removed) — don't auto-select
            if (currentAllocation === null && allocations.length > 0 && !userChangedAllocationRef.current) {
              const autoSelectedId = allocations[0].AllocationId;
              setAllocation(autoSelectedId);
              // Treat auto-selected allocation as "loaded" so that subsequent spec changes
              // will detect it as a current value and show a warning if it becomes unavailable.
              currentAllocationRef.current = autoSelectedId;
            }
          }
          else {
            setAvailableAllocations([]);
          }

        } catch (error) {
          onError(error);
        }
        finally {
          loader(false);
        }
      })()
    }
  }, [agent, company, rateId, promotionId, selectedProduct, reservation?.RoomTypeId, reservation?.CheckInDate, reservation?.CheckOutDate, reservationLoaded]);

  const mandatoryAllocationFieldsSupplied = () => {
    return rateId && reservation?.RoomTypeId && (agent || company) && selectedProduct;
  }

  const setGuestItem = (item) => {
    (async () => {
      if (item && guest && item.Id === guest.Id) {
        setGuestObj((prev) => {
          return {
            ...prev,
            ...item,
          };
        });
      } else {
        if (item?.Id && !item.Id?.toString().startsWith("newguest-")) {
          var result = await Guests.GetGuests({
            Id: item.Id,
            Includes: ["GuestClubs"],
          });
          let guestClub = result[0]?.GuestClubs[0];
          if (guestClub != null) {
            const clubs = await Clubs.GetClubs({ IsActive: true });
            guestClub.Club = clubs[0];
            setClubMemberDetails(guestClub);
            item.GuestClubs = [guestClub];
          } else {
            setClubMemberDetails(null);
          }
        }
        setGuestObj(item);
      }
    })();
  };
  const setGuesuClub = (club) => {
    setGuestObj((prevState) => ({
      ...prevState,
      GuestClubs: [club],
    }));
    const updated = guest
      ? {
        ...guest,
        GuestClubs: [club],
        Updated: true,
      }
      : { GuestClubs: club };
    setReservation((prev) => ({
      ...prev,
      Guest: updated,
    }));
  };
  const CheckClubMember = async ({ currentTarget }) => {
    loader(true);
    try {
      // setCheckingSpan(true);
      if (
        clubMemeberFeature &&
        (currentTarget.value || guest?.IdentityCardNumber)
      ) {
        const guestIdentity =
          currentTarget.value || guest?.IdentityCardNumber;
        const result = await Guests.CheckClubMember({
          Id: typeof guest?.Id != 'string' ? guest?.Id : 0,
          IdentityCardNumber: guestIdentity,
          Includes: [
            'ClubMembership',
            'GuestClubs'
          ]
        })

        if (result?.GuestClubs?.length > 0) {
          const clubs = await Clubs.GetClubs({ IsActive: true });
          result.GuestClubs[0].Club = clubs[0];
          result.GuestClubs[0].ClubId = clubs[0].Id;

          setClubMemberDetails(result.GuestClubs[0]);
          setGuesuClub(result?.GuestClubs[0]);
          await clubResultPopup(result.GuestClubs[0]);
        }
        else {
          setClubMemberDetails(null);
          await clubResultPopup(null);
        }
      }
      else {
        setClubMemberDetails(null);
      }
    } catch (error) {
      onError(error);
    } finally {
      //setCheckingSpan(false);
      loader(false);
    }
  };
  const clubResultPopup = (clubDetails) => {

    loader(false);

    return new Promise((resolve) => {
      setclubMemberPopup(
        <Modal {...rest} size="tiny">
          <Modal.Content>
            {clubDetails && (
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ margin: "0 5px" }}>
                    {clubDetails.Club.Name}
                  </span>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <span style={{ margin: "0 5px" }}>
                    {clubDetails.Description}
                  </span>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <span style={{ margin: "0 5px", order: 1 }}>
                    {moment(clubDetails.EnrollmentDate).format(dateFormat)} -{" "}
                    {moment(clubDetails.EndDate).format(dateFormat)}
                  </span>
                </div>
                <p style={{ margin: 0 }}>{message("CheckClubMemberDates")}</p>
              </div>
            )}
            {!clubDetails && (
              <div>
                <p>{message("GuestMemberNotFound")}</p>
              </div>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              size="small"
              onClick={() => {
                resolve(false);
                setclubMemberPopup(null);
              }}
            >
              {text("Close")}
            </Button>
          </Modal.Actions>
        </Modal>
      );
    });
  };

  const initializeReservation = async () => {
    try {
      loader(true);
      // Reset Guest
      setGuestObj(null);
      const defaultReservation = {};
      const hotelDefaults = await HotelDefaultReservationValues.GetDefaultReservationValues({
        HotelId: hotelid
      });
      const hotelParams = await GetHotelParameters({ ID: hotelid });
      setHotelParams(hotelParams);
      if (hotelDefaults) {
        _.mergeWith(
          defaultReservation,
          _.pick(
            hotelDefaults,
            "Adults",
            "Children",
            "Infants",
            "AgentId",
            "CompanyId",
            "PaymentTypeId",
            "Nights"
          ),
          (a, b) => (b ? b : a)
        );
      }

      if (!initialReservation.Eta || !initialReservation.Edt) {
        if (
          hotelParams &&
          hotelParams.CurrentHotel &&
          hotelParams.CurrentHotel.length
        ) {
          defaultReservation.Eta = hotelParams.CurrentHotel[0].Eta || "14:00";
          defaultReservation.Edt =
            hotelParams.CurrentHotel[0].HotelParameter.Etd || "11:00";
        } else {
          defaultReservation.Eta = "14:00";
          defaultReservation.Edt = "11:00";
        }
      }

      if (!initialReservation.CheckInDate || !initialReservation.CheckOutDate) {
        defaultReservation.CheckInDate = moment().startOf("day").toDate();
        defaultReservation.CheckOutDate = moment()
          .add(defaultReservation.Nights ?? 1, "days")
          .startOf("day")
          .toDate();
      }

      if (defaultReservation.AgentId) {
        const customers = await GetCustomers({
          "Ids[0]": defaultReservation.AgentId,
          IncludeCustomerProductCommission: true,
          GetOnlyCustomerArray: true,
        });
        if (customers && customers.length) {
          defaultReservation.Agent = customers[0];
          if (defaultReservation.Agent) {
            defaultReservation.PaymentArrangementId =
              defaultReservation.Agent.DefaultPaymentArrangementId;
            defaultReservation.ReservationSourceID =
              defaultReservation.Agent.DefaultReservationSourceID;
            defaultReservation.MarketSegmentID =
              defaultReservation.Agent.DefaultReservationMarketSegmentID;
          }
        }
      } else if (defaultReservation.CompanyId) {
        const customers = await GetCustomers({
          "Ids[0]": defaultReservation.CompanyId,
          IncludeCustomerProductCommission: true,
          GetOnlyCustomerArray: true,
        });
        if (customers && customers.length) {
          defaultReservation.Company = customers[0];
          if (defaultReservation.Company) {
            defaultReservation.PaymentArrangementId =
              defaultReservation.Company.DefaultPaymentArrangementId;
            defaultReservation.ReservationSourceID =
              defaultReservation.Company.DefaultReservationSourceID;
            defaultReservation.MarketSegmentID =
              defaultReservation.Company.DefaultReservationMarketSegmentID;
          }
        }
      }
      // Determine default nationality: Agent > Company > Hotel Parameters
      const effectiveNationalityId =
        defaultReservation.Agent?.DefaultNationalityId ||
        defaultReservation.Company?.DefaultNationalityId ||
        defaultNationalityId;

      if (effectiveNationalityId) {
        defaultReservation.Guest = {
          NationalityId: effectiveNationalityId,
        };
        setGuestItem({
          NationalityId: effectiveNationalityId,
          Updated: true,
        });
      }
      //If hotel-reservation doesn't have default PAX distribution, assign the below
      defaultReservation.Adults ??= 2;
      defaultReservation.Children ??= 0;
      defaultReservation.Infants ??= 0;

      const defaultProducts = await HotelDefaultReservationValues.GetDefaultReservationProducts({
        HotelId: hotelid,
        FromDate: moment(initialReservation.CheckInDate || defaultReservation.CheckInDate).toISOString(),
        ToDate: moment(initialReservation.CheckOutDate || defaultReservation.CheckOutDate).toISOString(),
        IncludeProductPrices: true,
      });
      const product = _.find(defaultProducts, [
        "RoomTypeId",
        initialReservation.RoomTypeId,
      ]);
      if (product) {
        defaultReservation.ProductId = product.ProductId;
        defaultReservation.RoomTypeId = product.RoomTypeId;
        defaultReservation.CurrencyId = product.CurrencyId;
        //Update related values
        initialReservation.TotalAmountProductCurrentBeforeTax = product.Product?.TotalPriceBeforeTax;
        initialReservation.TotalAmountProductCurrentAfterTax = product.Product?.TotalPriceAfterTax;
        initialReservation.ReservationPolicyId = product.Product?.ReservationPolicyId;
        initialReservation.ReservationPolicy = product.Product?.ReservationPolicy;
        initialReservation.ReservationDailyAddons = []
        initialReservation.ReservationDailyAccommodations = [];
        setSelectedProduct(product.Product);
        initialProductRef.current = product.Product;
      }

      setReservation({
        ...defaultReservation,
        ...initialReservation,
        HotelId: hotelid,
      });

      setAgentItem(defaultReservation.Agent);
      setCompanyItem(defaultReservation.Company);
      setDefaults(hotelDefaults);
    } catch (error) {
      onError(error);
    } finally {
      loader(false);
    }
  };

  const confirmNewGuest = () => {
    return new Promise((resolve) => {
      setConfirmNewGuestElement(
        <Confirm
          open
          className="centered-confirm"
          confirmButton={text("CreateNewGuest")}
          cancelButton={text("UpdateExisting")}
          content={text("ConfirmCreateNewGuest")}
          onConfirm={() => {
            resolve(true);
          }}
          onCancel={() => {
            resolve(false);
            setConfirmNewGuestElement(null);
          }}
        ></Confirm>
      );
    });
  };

  const saveAction = async () => {
    if (insufficientAddon) {
        onWarning("Addon has insufficient quantity")
        return false;
    }
    // Check if guest was edited and if there is a need to create a new guest
    const validatedData = reservation.ReservationDailyAddons.filter(x => x.HotelAddonId && ((x.Quantity || 0) + (x.AdultQuantity || 0) + (x.ChildQuantity || 0) + (x.InfantQuantity || 0) > 0))
    const _reservationDailyAddons = [...validatedData, ...reservationDailyAddonsForDeletion];

    const clone = {
      ...reservation,
      ReservationDailyAddons: _reservationDailyAddons,
      RenderFoliosImmediately: true
    };
    if (reservation.Guest && reservation.Guest.Updated) {
      if (reservation.Guest.Id.toString().startsWith("newguest-")) {
        clone.Guest.Id = 0;
        clone.GuestId = null;
      } else if (reservation.GuestId) {
        const newGuest = await confirmNewGuest();
        if (newGuest) {
          clone.Guest.Id = 0;
          clone.GuestId = null;
        }
      }
    }

    if (!checkEmailValid(guest?.Email)) {
      onWarning(message("InvalidEmail"));
      return;
    }
    const addons = selectedProduct?.DailyPrices?.filter(x => x.PricingElementEntityTypeId === EntityType.AddOn)
    const totalAddons = _.sumBy(addons, "PriceBeforeTax")
    if (reservation.TotalAmountProductCurrentBeforeTax - totalAddons < 0) {
      return onWarning(message("ReservationOverrideAmountIsLessThenAddonAmount").replace('{0}', totalAddons.toFixed(2)))
    }

    try {
      setIsSaving(true);
      loader(true);

      if (mandatoryAllocationFieldsSupplied()) {
        clone.AllocationId = allocation || 0;
      }
      else {
        clone.AllocationId = 0;
      }

      let updated = await SaveReservation(CleanReservationProps(clone));
      /*PAY ATTENTION- currently refetching reservation from server instead of using
        the return value of saveReservation due to differences in Id capitalizations
        between OP2 and OP3 - should be changed once saveRes works with OP3 */
      updated = await GetSingleReservation(updated);

      if (paymentDialogRef.current) {
        const result = await paymentDialogRef.current.saveAction({
          folioId: updated.FolioId,
          entities: [
            {
              type: 1,
              id: updated.Id,
            },
            {
              type: 3,
              id: updated.GuestId,
            },
          ],
        });
        if (result) {
          if (result.PathOriginal) {
            saveAs(result.PathOriginal);
          }
          if (result.PathCopy) {
            saveAs(result.PathCopy);
          }
          window.postMessage({
            type: "CreditCardsUpdated",
          });
        }
      }

      if (onSave) onSave([updated]);
      if (onClose) onClose();
      resetFormState();
      onSuccess();
    } catch (error) {
      console.error(error);
      error.status === 400 ? onWarning(error) : onError(error);
    } finally {
      setDisplaySave(true);
      loader(false);
      setIsSaving(false);
    }
  };

  const closeAction = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    resetFormState();
    if (onClose) onClose();
  };

  const recalcCheckInOutDates = (checkInDate, checkOutDate) => {
    // Ensure checkInDate and checkOutDate are valid Date objects
    if (checkInDate && (!(checkInDate instanceof Date) || isNaN(checkInDate.getTime()))) {
      checkInDate = moment(checkInDate).toDate();
    }
    if (checkOutDate && (!(checkOutDate instanceof Date) || isNaN(checkOutDate.getTime()))) {
      checkOutDate = moment(checkOutDate).toDate();
    }

    if (checkInDate && checkInDate instanceof Date && !isNaN(checkInDate.getTime()) && reservation.Eta && reservation.Eta.includes(":")) {
      checkInDate.setHours(reservation.Eta.split(":")[0]);
      checkInDate.setMinutes(reservation.Eta.split(":")[1]);
    }
    if (checkOutDate && checkOutDate instanceof Date && !isNaN(checkOutDate.getTime()) && reservation.Edt && reservation.Edt.includes(":")) {
      checkOutDate.setHours(reservation.Edt.split(":")[0]);
      checkOutDate.setMinutes(reservation.Edt.split(":")[1]);
    }

    if (checkInDate && checkOutDate && checkOutDate < checkInDate) {
      checkOutDate = moment(checkInDate).add(1, "day").toDate();
      if (checkOutDate && reservation.Edt && reservation.Edt.includes(":")) {
        checkOutDate.setHours(reservation.Edt.split(":")[0]);
        checkOutDate.setMinutes(reservation.Edt.split(":")[1]);
      }
    }

    return {
      checkInDate,
      checkOutDate,
    };
  };

  const setCheckInDate = (val) => {
    const updatedDates = recalcCheckInOutDates(
      val,
      moment(reservation.CheckOutDate).toDate()
    );
    RebuildReservation(
      reservation,
      updatedDates.checkInDate,
      updatedDates.checkOutDate
    );
    // Reset product context ref so setProductItem will run again to recalculate prices for new dates
    currentProductKeyRef.current = null;
    // Clear selected product so the dropdown will rebind with new date range
    setSelectedProduct(null);
    setRateId(null);
    setPromotionId(null);
    setDiscountPercent(0);
    setReservation((prev) => ({
      ...prev,
      ProductId: null,
      PromotionId: null,
      TotalAmountProductCurrentBeforeTax: null,
      TotalAmountProductCurrentAfterTax: null,
      ReservationDailyAccommodations: [],
      // Only keep extra addons (ones without ProductId)
      ReservationDailyAddons: prev.ReservationDailyAddons?.filter(addon => !addon.ProductId) || []
    }));
  };
  const setCheckOutDate = (val) => {
    const updatedDates = recalcCheckInOutDates(
      moment(reservation.CheckInDate).toDate(),
      val
    );
    RebuildReservation(
      reservation,
      updatedDates.checkInDate,
      updatedDates.checkOutDate
    );
    // Reset product context ref so setProductItem will run again to recalculate prices for new dates
    currentProductKeyRef.current = null;
    // Clear selected product so the dropdown will rebind with new date range
    setSelectedProduct(null);
    setRateId(null);
    setPromotionId(null);
    setDiscountPercent(0);
    setReservation((prev) => ({
      ...prev,
      ProductId: null,
      PromotionId: null,
      TotalAmountProductCurrentBeforeTax: null,
      TotalAmountProductCurrentAfterTax: null,
      ReservationDailyAccommodations: [],
      // Only keep extra addons (ones without ProductId)
      ReservationDailyAddons: prev.ReservationDailyAddons?.filter(addon => !addon.ProductId) || []
    }));
  };

  const setReservationPax = (prop, val, reservation) => {
    val = Number(val);
    const delta = val - reservation[prop];
    reservation[prop] = val;
    if (reservation.ReservationDailyAccommodations) {
      reservation.ReservationDailyAccommodations.forEach((accomodation) => {
        accomodation[prop] = val;
      });
    }
    const addonprops = {
      Adults: "AdultQuantity",
      Children: "ChildQuantity",
      Infants: "InfantQuantity",
    };
    if (
      reservation.ReservationDailyAddons &&
      reservation.ReservationDailyAddons.length > 0
    ) {
      reservation.ReservationDailyAddons.forEach((addon) => {
        if (addon.ProductId) {
          addon[addonprops[prop]] = val;
        }
      });
      //if price type is fixed and the reservation has addons then recalc
      RecalcReservationForFixedPricesPaxChange(reservation, prop, delta);
    }

    //Resetting ReservationDailyAccommodations for the backend to re-calculate them
    reservation.ReservationDailyAccommodations = [];
  };
  const setEta = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Eta: val }));
  }, []);
  const setEDT = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Edt: val }));
  }, []);
  const setAdults = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Adults", val, prev);
      return { ...prev };
    });
  }, []);
  const setChildren = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Children", val, prev);
      return { ...prev };
    });
  }, []);
  const setInfants = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Infants", val, prev);
      return { ...prev };
    });
  }, []);
  const setRoomType = useCallback((val) => {
    const defaultProducts =
      defaults && defaults.HotelDefaultReservationProductsViewModel;
    const product = _.find(defaultProducts, ["RoomTypeId", val]);
    setReservation((prev) => {
      return {
        ...prev,
        RoomTypeId: val,
        ProductId: product && product.ProductID,
        UpgradedFromRoomTypeID: null,
      };
    });
  }, [defaults]);
  const setRoom = useCallback((val) => {
    setReservation((prev) => {
      if (prev.ReservationDailyAccommodations) {
        _.forEach(prev.ReservationDailyAccommodations, (accomodation) => {
          accomodation.RoomId = val?.Id;
        });
      }
      return { ...prev, RoomId: val?.Id, WingId: val?.WingID };
    });
  }, []);
  const toggleDNC = useCallback(() => {
    if (!reservation.IsDoNotChangeRoom) {
      setShowRoomLockConfirm(true);
    } else {
      setShowRoomUnlockConfirm(true);
    }
  }, [reservation.IsDoNotChangeRoom]);

  const confirmDNCLock = useCallback(() => {
    setReservation((prev) => ({ ...prev, IsDoNotChangeRoom: true }));
    setShowRoomLockConfirm(false);
  }, []);

  const confirmDNCUnlock = useCallback(() => {
    setReservation((prev) => ({ ...prev, IsDoNotChangeRoom: false }));
    setShowRoomUnlockConfirm(false);
  }, []);

  const setExternalMasterID = useCallback((val) => {
    setReservation((prev) => ({ ...prev, ExternalReservationMasterId: val }));
  }, []);

  const setComments = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Comments: val }));
  }, []);

  const setCommentsForGuest = useCallback((val) => {
    setReservation((prev) => ({ ...prev, CommentsVisibleToGuest: val }));
  }, []);

  const setGuest = useCallback((val) => {
    if (val && val.toString().startsWith('newguest-')) {
      return;
    }
    setReservation((prev) => ({ ...prev, GuestId: val, Guest: null }));
  }, [guest]);

  const setNewGuest = useCallback((updated) => {
    if (updated) {
      if (!updated.FirstName || !updated.LastName) {
        onWarning('Full name is required!');
        return;
      }
      if (updated.Id.toString().startsWith('newguest-')) {
        updated.NationalityId = updated.NationalityId || defaultNationalityId
      }
      updated.Updated = true;
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
        GuestId: updated.Id,
      }));
      setGuestItem(updated);
    } else {
      setReservation((prev) => ({ ...prev, Guest: null, GuestId: null }));
      setGuestItem(null);
    }
  }, [defaultNationalityId]);

  const setAgent = useCallback((val) => {
    setReservation((prev) => ({ ...prev, AgentId: val, Agent: null }));
  }, []);

  const onChangeAgentItem = useCallback((agent) => {
    setAgentItem(agent);
    setReservation((prev) => {
      const updated = {
        ...prev,
        PaymentArrangementId: agent?.DefaultPaymentArrangementId,
      };

      // Apply nationality: Agent's default > Company's default > Hotel's default
      // When agent is cleared or has no default, fallback to company's default, then hotel default
      const effectiveNationality = agent?.DefaultNationalityId || company?.DefaultNationalityId || defaultNationalityId;
      if (effectiveNationality) {
        const updatedGuest = {
          ...(prev.Guest || guest || {}),
          NationalityId: effectiveNationality,
          Updated: true,
        };
        updated.Guest = updatedGuest;
        setGuestItem(updatedGuest);
      }

      return updated;
    });
  }, [guest, company, defaultNationalityId]);

  const setCompany = useCallback((val) => {
    setReservation((prev) => ({ ...prev, CompanyId: val, Company: null }));
  }, []);

  const onChangeCompanyItem = useCallback((company) => {
    setCompanyItem(company);
    setReservation((prev) => {
      const updated = {
        ...prev,
        PaymentArrangementId: company?.DefaultPaymentArrangementId,
      };

      // Apply nationality: Agent's default > Company's default > Hotel's default
      // Only apply if no agent has a DefaultNationalityId
      if (!agent?.DefaultNationalityId) {
        const effectiveNationality = company?.DefaultNationalityId || defaultNationalityId;
        if (effectiveNationality) {
          const updatedGuest = {
            ...(prev.Guest || guest || {}),
            NationalityId: effectiveNationality,
            Updated: true,
          };
          updated.Guest = updatedGuest;
          setGuestItem(updatedGuest);
        }
      }

      return updated;
    });
  }, [agent, guest, defaultNationalityId]);

  const setVoucherNumber = useCallback((val) => {
    setReservation((prev) => ({ ...prev, VoucherNumber: val }));
  }, []);

  const setReservationSource = useCallback((val) => {
    setReservation((prev) => ({
      ...prev,
      ReservationSourceID: val,
      ReservationSource: null,
    }));
  }, []);

  const setEmail = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          Email: val,
          Updated: true,
        }
        : { Email: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );

  const setIdentityCardNumber = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          IdentityCardNumber: val,
          Updated: true,
        }
        : { IdentityCardNumber: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );
  const setPhone = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          Phone: val,
          Updated: true,
        }
        : { Phone: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );
  const setNationality = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          NationalityId: val,
          Updated: true,
        }
        : { NationalityId: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );
  const buildReservationDailyAddonsFromProduct = (product) => {
    const addons = product?.DailyPrices?.filter(x => x.PricingElementEntityTypeId === EntityType.AddOn) || []
    return addons
      .map(addon => {
        const hotelAddon = hotelAddons?.find(ha => ha.ChainAddonId === addon.PricingElementEntityId);
        // Skip addons where no matching HotelAddon is found - this prevents FK constraint violations
        if (!hotelAddon?.Id) {
          console.warn(`No HotelAddon found for ChainAddonId: ${addon.PricingElementEntityId}`);
          return null;
        }
        return ({
          ProductId: product.Id,
          Date: moment(addon.Date).startOf('day').toDate(),
          HotelAddonId: hotelAddon.Id,
          HotelAddon: hotelAddon,
          AdultQuantity: reservation.Adults,
          ChildQuantity: reservation.Children,
          InfantQuantity: reservation.Infants,
          CurrencyId: product.CurrencyId
        });
      })
      .filter(addon => addon !== null); // Remove null entries (addons without valid HotelAddonId)
  }

  const setProductItem = useCallback(async (product) => {
    // Guard: skip if the product key hasn't changed
    const newKey = product?.ProductKey ?? null;
    if (newKey === currentProductKeyRef.current) return;

    currentProductKeyRef.current = newKey;

    const currencyID = product
      ? product.Currency
        ? product.Currency.Id
        : product.CurrencyId
      : null;

    const productDailyAddons = buildReservationDailyAddonsFromProduct(product);

    setReservation((prev) => {
      // Preserve existing addons that are NOT from a product (extra addons added manually)
      const existingExtraAddons = (prev.ReservationDailyAddons || []).filter(addon => !addon.ProductId);

      return {
        ...prev,
        CurrencyId: currencyID,
        ProductId: product?.PromotionId ? product?.BaseProductId : product?.Id,
        PromotionId: product?.PromotionId,
        DiscountByPercent: 0,
        TotalAmountProductCurrentBeforeTax: product?.TotalPriceBeforeTax,
        TotalAmountProductCurrentAfterTax: product?.TotalPriceAfterTax,
        // Remove any daily values to rebuild by the server when changing product
        ReservationDailyAccommodations: [],
        // Combine product addons with existing extra addons (ones without ProductId)
        ReservationDailyAddons: [...productDailyAddons, ...existingExtraAddons]
      };
    });

    setDiscountPercent(0);
    setRateId(product?.RateId);
    setPromotionId(product?.PromotionId);
    setSelectedProduct(product)
    updateReservationPolicy(product)

    // If product has a promotion, fetch policy from promotion instead of product
    if (product?.PromotionId) {
      try {
        // Get the promotion to check if it has a ReservationPolicyId
        const promotions = await Promotions.GetPromotions({
          Ids: [product.PromotionId]
        });

        if (promotions?.length && promotions[0].PolicyId) {
          // Fetch the reservation policy from the promotion
          const policies = await ReservationPolicyAPI.GetReservationPolicies({
            Id: promotions[0].PolicyId
          });

          if (policies?.length) {
            const promotionPolicy = policies[0];
            setPromoPolicy(promotionPolicy);
          } else {
            setPromoPolicy(null);
          }
        } else {
          setPromoPolicy(null);
        }
      } catch (error) {
        console.error('Failed to fetch promotion policy:', error);
        setPromoPolicy(null);
      }
    } else {
      setPromoPolicy(null);
    }
  }, [hotelAddons]);

  const handleApplyNewPolicy = useCallback(() => {
    setReservation((prev) => ({
      ...prev,
      ReservationPolicyId: newPolicyDetails?.Id,
      ReservationPolicy: newPolicyDetails
    }));
    setShowPolicyChangePopup(false)
  }, [newPolicyDetails]);

  const updateReservationPolicy = (product) => {
    if (!product || !product.ReservationPolicy) return;

    // Only show confirmation popup if this is an existing reservation and the policy is different
    if (initialReservation?.Id &&
      initialReservation?.ReservationPolicyId &&
      product.ReservationPolicyId !== initialReservation.ReservationPolicyId) {

      const isProductChanged = initialReservation.ProductId != product.Id ||
        !moment(initialReservation.CheckInDate).isSame(moment(reservation.CheckInDate), "date") ||
        !moment(initialReservation.CheckOutDate).isSame(moment(reservation.CheckOutDate), "date");

      if (isProductChanged) {
        setShowPolicyChangePopup(true);
        setNewPolicyDetails(product?.ReservationPolicy);
      }
    }
    else
      setReservation((prev) => ({
        ...prev,
        ReservationPolicyId: product?.ReservationPolicy?.Id,
        ReservationPolicy: product?.ReservationPolicy
      }));
  };


  const setPricingType = useCallback((val) => {
    if (val == 4) {
      setReservation((prev) => ({
        ...prev,
        ReservationPricingTypeId: val,
        DiscountByPercent: 100,
        DiscountByAmount: getPriceBeforeDiscount(
          prev.DiscountByPercent,
          prev.TotalAmountProductCurrentBeforeTax
        ),
      }));
      setDiscountPercent(100);
    } else {
      setReservation((prev) => ({
        ...prev,
        ReservationPricingTypeId: val,
        DiscountByPercent: 0,
        DiscountByAmount: 0,
      }));
      setDiscountPercent(0);
    }
  }, []);

  const setTotalPrice = (val, isAfterTax) => {
    (async () => {
      try {
        const value = Number(val);
        const calculatedValue = await calculateManualPriceTaxes(val, isAfterTax)

        const updated = {
          ...reservation,
          TotalAmountProductCurrentBeforeTax: isAfterTax
            ? calculatedValue
            : value,
          TotalAmountProductCurrentAfterTax: isAfterTax
            ? value
            : calculatedValue,
          OverriddenTotalAmount: value,
          IsOverriddenTotalAmountAfterTax: isAfterTax,
          OverrideProductPrice: true,
          RefetchReservation: false,
          DiscountByPercent: 0,
        };
        setDiscountPercent(0);
        setReservation(updated);
      } catch (error) {
        onError(error)
      }
    })()
  };
  const calculateManualPriceTaxes = async (val, isAfterTax) => {
    try {
      var totalAddonsAmountAfterTax = reservation.TotalAmountProductAddonsAfterTax ?? 0;
      var totalAddonsAmountBeforeTax = reservation.TotalAmountProductAddonsBeforeTax ?? 0;

      if (selectedProduct?.DailyPrices?.length > 0) {
        const dailyAddons = selectedProduct.DailyPrices?.filter(x => x.PricingElementEntityTypeId === EntityType.AddOn)
        totalAddonsAmountAfterTax = _.sumBy(dailyAddons, "PriceAfterTax");
        totalAddonsAmountBeforeTax = _.sumBy(dailyAddons, "PriceBeforeTax");
      }

      val -= isAfterTax ? totalAddonsAmountAfterTax : totalAddonsAmountBeforeTax;

      const calculatePrice = await calculateAccomodationTaxes(reservation, val, isAfterTax, currentHotel.Id)

      return _.sumBy(calculatePrice.Items, isAfterTax ? "AmountBeforeTax" : "AmountAfterTax") + (isAfterTax ? totalAddonsAmountBeforeTax : totalAddonsAmountAfterTax)
    }
    catch (error) {
      onError(error)
    }
  }

  const discountPercentChanged = (value) => {
    (async () => {
      try {
        if (value != reservation.DiscountByPercent && reservation.TotalAmountProductCurrentBeforeTax != null) {
          var isBackFromFixedFreePrice = value == 0 && reservation.DiscountByPercent == 100;
          var originalPrice = isBackFromFixedFreePrice ? reservation.DiscountByAmount : getPriceBeforeDiscount(reservation.DiscountByPercent ?? 0, reservation.TotalAmountProductCurrentBeforeTax);
          var amountAfterCurrentDiscount = value ? originalPrice - originalPrice * (value / 100)
            : originalPrice;

          const calculatedPrice = await calculateManualPriceTaxes(amountAfterCurrentDiscount, false)

          const updated = {
            ...reservation,
            TotalAmountProductCurrentBeforeTax: amountAfterCurrentDiscount,
            TotalAmountProductCurrentAfterTax: calculatedPrice,
            DiscountByPercent: value,
            IsOverriddenTotalAmountAfterTax: false,
            OverrideProductPrice: true,
            RefetchReservation: false,
            OverriddenTotalAmount: amountAfterCurrentDiscount,
            DiscountTypeId: value ? 4 : null,
            DiscountByAmount: originalPrice - amountAfterCurrentDiscount,
            DiscountAuthorizedByUserId: window.user?.Id
          };
          if (value == 100) {
            updated.ReservationPricingTypeId = 4;
            setPricingType(4);
          }
          setDiscountPercent(value);
          setReservation(updated);
        }
      }
      catch (error) {
        onError(error)
      }
    })()
  };

  const getPriceBeforeDiscount = (percent, fullPrice) => {
    var pricePercent = (100 - percent) / percent;
    var percentOfPrice = fullPrice / (pricePercent * 100);
    return fullPrice + percentOfPrice * 100;
  };

  const ProductsSpec = React.useMemo(() => {
    if (_.isEmpty(reservation) || !reservation.HotelId)
      return null;

    let spec = {
      HotelID: reservation.HotelId,
      GetPricingForLastDateOfRange: moment(reservation.CheckInDate).isSame(
        reservation.CheckOutDate,
        'day'
      ),
      "Pax.Adults": reservation.Adults,
      "Pax.Children": reservation.Children,
      "Pax.Infants": reservation.Infants,
      "Pax.Total": (reservation.Adults || 0) + (reservation.Children || 0) + (reservation.Infants || 0),
      RoomTypeId:
        reservation.UpgradedFromRoomTypeId || reservation.RoomTypeId,
      FromDate:
        reservation.CheckInDate && reservation.CheckOutDate
          ? moment(reservation.CheckInDate).toISOString() : null,
      ToDate:
        reservation.CheckInDate && reservation.CheckOutDate
          ? moment(reservation.CheckOutDate).toISOString() : null,
      IgnoreRestrictions: UserHasPermission(
        PermissionsActions.AllowSelectionOfRestrictedProducts
      ),
      ConsiderAvailability: true,
      IncludeRateAvailabilitySettings: true,
      LanguageId: window.optima?.user?.UserSettings[0]?.LanguageID,
      IncludeReservationPolicyAutoDescription: true,
      IncludePromotions: true,
      IncludeBaseProductsWithPromotions: true,
      Includes: [
        "ProductPrices",
        "DailyProductPrices",
        "Restrictions",
        "Rate",
        "ProductElements",
        "ReservationPolicy"
      ]
    };
    let index = 0;

    // Only one CustomerId must be selected, AgentId takes precedence
    if (reservation.AgentId && reservation.AgentId !== '') {
      spec[`CustomerIds[${index}]`] = reservation.AgentId
      index++;
    }
    else if (reservation.CompanyId && reservation.CompanyId !== '') {
      spec[`CustomerIds[${index}]`] = reservation.CompanyId
    }
    return spec
  }, [
    reservation.HotelId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.RoomTypeId,
    reservation.UpgradedFromRoomTypeID,
    reservation.CheckInDate,
    reservation.CheckOutDate,
    reservation.AgentId,
    reservation.CompanyId
  ]);

  const RoomTypesSpec = React.useMemo(() => {
    return _.isEmpty(reservation)
      ? null
      : {
        HotelID: reservation.HotelId,
      };
  }, [reservation.HotelId]);

  const RoomsSpec = React.useMemo(() => {
    return _.isEmpty(reservation)
      ? null
      : {
        HotelID: reservation.HotelId,
        RoomTypeIDs: reservation.RoomTypeId,
        FromAdultsMaxPax: reservation.Adults,
        FromChildrenMaxPax: reservation.Children,
        FromInfantsMaxPax: reservation.Infants,
        AvailableFrom: moment(reservation.CheckInDate).toISOString(),
        AvailableTo: moment(reservation.CheckOutDate).toISOString(),
        ExcludeInActive: true,
        IgonreReservationIDs: reservation.Id || null,
        FilterOutPlannedMaintanance: true,
      };
  }, [
    reservation.HotelId,
    reservation.RoomTypeId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.CheckInDate,
    reservation.CheckOutDate,
  ]);

  const AgentsSpec = React.useMemo(() => {
    return {
      CustomerTypeId: 2,
      GetOnlyCustomerArray: true,
      IsActive: true,
      IncludeCustomerProductCommission: true,
    };
  }, []);
  const CompaniesSpec = React.useMemo(() => {
    return {
      CustomerTypeId: 1,
      GetOnlyCustomerArray: true,
      IsActive: true,
      IncludeCustomerProductCommission: true,
    };
  }, []);

  const currencyFormat = (currencyID) => {
    return {
      format: "%v%s",
      symbol: Currencies[currencyID]?.symbol,
      locale: document.documentElement.lang || "he-IL",
    };
  };

  const productLabel = React.useCallback((item) => {
    return formatCurrency(
      item.TotalPriceAfterTax,
      currencyFormat(item.CurrencyId)
    );
  }, []);

  const currencySymbol =
    Currencies[reservation.CurrencyId ? reservation.CurrencyId : 1]?.symbol;

  const missingMasterId = useCallback(() => {
    if (agent && agent.ExternalChannelID) {
      return !reservation.ExternalReservationMasterId;
    } else {
      return false;
    }
  }, [agent, reservation.ExternalReservationMasterId]);

  const commisionIncompatableCurrency = useCallback(() => {
    let result = false;
    if (
      agent &&
      agent.CustomerHotelProductCommissions &&
      agent.CustomerHotelProductCommissions.length
    ) {
      agent.CustomerHotelProductCommissions.forEach((commission) => {
        result =
          result ||
          (commission.FixedCommissionAmountBeforeTax &&
            commission.FixedCommissionCurrencyID !== reservation.CurrencyId);
      });
    }
    if (
      company &&
      company.CustomerHotelProductCommissions &&
      company.CustomerHotelProductCommissions.length
    ) {
      company.CustomerHotelProductCommissions.forEach((commission) => {
        result =
          result ||
          (commission.FixedCommissionAmountBeforeTax &&
            commission.FixedCommissionCurrencyID !== reservation.CurrencyId);
      });
    }
    return result;
  }, [agent, company, reservation]);

  const isSaveEnabled = useMemo(() => {
    return (
      !isSaving &&
      reservation.ProductId &&
      reservation.RoomTypeId &&
      reservation.GuestId !== null &&
      reservation.GuestId !== undefined &&
      (!clubMemeberFeature ||
        reservation.Guest?.IdentityCardNumber ||
        guest?.IdentityCardNumber) &&
      !missingMasterId()
    );
  }, [
    isSaving,
    reservation.ProductId,
    reservation.RoomTypeId,
    reservation.GuestId,
    agent,
    reservation.ExternalReservationMasterId,
    reservation.Guest?.IdentityCardNumber,
    guest?.IdentityCardNumber
  ]);

  const fullReservation = useCallback(async () => {
    if (reservation.Id) {
      window.open(
        `${endpoint}PMS/Reservations/Index/${reservation.Id}?hotelid=${reservation.HotelId}`,
        "_blank"
      );
    } else {
      // Get Company and agent
      const customers = await GetCustomers({
        "Ids[0]": reservation.AgentId,
        "Ids[1]": reservation.CompanyId,
        GetOnlyCustomerArray: true,
      });
      const guests = await GetGuests({
        IDs: reservation.GuestId,
      });

      const reservationGuest = guests.find(
        (x) => x.Id === reservation.GuestId
      ) ||
        guest || {
        NationalityId: defaultNationalityId,
      };

      const effectiveWingId = reservation.WingId ?? initialReservation?.WingId;
      localStorage.setItem(
        "reservationViewModel",
        JSON.stringify([
          {
            // TODO - Temporary workaround until all variable names are proper camelCase
            ..._.omit(reservation, [
              "CompanyId",
              "AgentId",
              "WingId",
              "ProductId",
            ]),
            CompanyID: reservation.CompanyId,
            AgentID: reservation.AgentId,
            WingID: effectiveWingId,
            ProductID: reservation.ProductId,
            Agent: customers.find((x) => x.Id === reservation.AgentId),
            Company: customers.find((x) => x.Id === reservation.CompanyId),
            Guest: {
              // TODO - Temporary workaround until all variable names are proper camelCase
              ..._.omit(reservationGuest, "NationalityId"),
              NationalityID: reservationGuest.NationalityId,
            },
          },
        ])
      );
      window.open(
        `${endpoint}PMS/Reservations/Index/?hotelid=${reservation.HotelId}&wingId=${effectiveWingId}`,
        "_blank"
      );
    }
    setGuestObj(null);
    setReservation({});
    if (onClose) onClose();
  }, [reservation, initialReservation, guest, defaultNationalityId, onClose]);

  const isEditPriceAllowed = useCallback(() => {
    return (
      reservation.ReservationPricingTypeId !==
      ReservationAmountOverrideType.Free &&
      UserHasPermission(PermissionsActions.EditPrice)
    );
  }, [reservation.ReservationPricingTypeId]);

  const isUserHasPermission = useCallback((actionId) => {
    return UserHasPermission(actionId);
  }, []);

  const isRoomLocked = reservation.IsDoNotChangeRoom === true;
  const canToggleRoomLock = isUserHasPermission(PermissionsActions.ToggleRoomLock);
  const isCheckedIn = reservation.StatusId === ReservationStatusesEnums.CheckedIn;
  const roomFieldsDisabledByLock = isRoomLocked && !canToggleRoomLock && !isCheckedIn;

  const balance =
    reservation?.totals?.TotalAmountDebitAfterTax +
    reservation?.totals?.TotalAmountCreditAfterTax;

  const Is3dsOpenChange = (is3dsOpen) => {
    setDisplaySave(!is3dsOpen);
  };

  const setReservationDailyAddons = (reservationDailyAddons) => {
    setReservation(reservation => ({
      ...reservation,
      ReservationDailyAddons: reservationDailyAddons
    }))
  }

  const resetFormState = useCallback(() => {
    setGuestObj(null);
    setReservation({});
    setDiscountPercent(0);
    setAllocation(null);
    setRateId(null);
    setPromotionId(null);
    setSelectedProduct(null);
    setPromoPolicy(null);
    currentProductKeyRef.current = null;
    initialProductRef.current = null;

    initialLoadRef.current = true;
    prevPaxRef.current = { Adults: null, Children: null, Infants: null };
    userChangedAllocationRef.current = false;
    currentAllocationRef.current = undefined;
    setReservationLoaded(false);
  }, []);

  const reservationPolicyPanels = useMemo(() => {
    if (!reservation?.ReservationPolicy && !promoPolicy) {
      return null;
    }
    return [
      {
        title: !promoPolicy ? reservation.ReservationPolicy?.Name : promoPolicy.Name,
        key: 'ReservationPolicy',
        content: {
          content: (
            <Header size="small">
              <Header.Content>

                {!promoPolicy ? <TextList text={buildAutoDescriptionForPolicy(reservation.ReservationPolicy, message, text, currentHotel?.HotelParameter?.TimeZone)} /> : <TextList text={buildAutoDescriptionForPolicy(promoPolicy, message, text, currentHotel?.HotelParameter?.TimeZone)} />}
              </Header.Content>
            </Header>
          )
        }
      }
    ]
  }, [reservation?.ReservationPolicy, promoPolicy])

  const reservationPolicyView = useMemo(() => {
    if (!reservation?.ReservationPolicy && !promoPolicy) {
      return null;
    }
    return (
      <div>
        <Divider />
        <Accordion panels={reservationPolicyPanels} />
      </div>
    )
  }, [reservation?.ReservationPolicy, promoPolicy, reservationPolicyPanels])

  /* eslint-disable react/display-name */
  const panes = useMemo(() => {
    const panes = [
      {
        menuItem: isMobileOnly
          ? { icon: "edit outline" }
          : text("RequiredDetails"),
        pane: (
          <Tab.Pane as={Form} key="general">
            {isMobileOnly && (
              <Form.Field
                control={HotelsDropDown}
                spec={{ IsActive: true }}
                label={text("Hotel")}
                onChange={(id) => {
                  setReservation({
                    ...reservation,
                    HotelId: id,
                  });
                  initializeReservation();
                }}
                value={reservation.HotelId}
              />
            )}
            <Form.Group>
              <Form.Field
                width="10"
                control={GuestSearchDropDown}
                placeholder={text("SearchByNameEmailPhoneId")}
                label={text("Guest")}
                guest={reservation.Guest}
                value={reservation.GuestId}
                onAddGuest={setNewGuest}
                onChange={setGuest}
                onChangeItem={setGuestItem} />
              <Form.Input
                width="6"
                label={text("GuestIdentityCardNumber")}
                value={guest ? guest.IdentityCardNumber || "" : ""}
                onChange={(e, { value }) => setIdentityCardNumber(value)}
                onBlur={CheckClubMember}
                required={clubMemeberFeature}
                icon
              >
                <input />
                {clubMemeberFeature && (
                  <Icon
                    name="star outline"
                    link
                    onClick={CheckClubMember}>
                  </Icon>
                )}
              </Form.Input>
              {/* {checkingSpan && (
                <span style={{ color: "red" }}>{text("checking")}</span>
              )} */}

            </Form.Group>
            <Form.Group>
              <Form.Input
                width="8"
                label={text("Email")}
                value={guest ? guest.Email || "" : ""}
                onChange={(e, { value }) => setEmail(value)}
              ></Form.Input>
              <Form.Input
                width="4"
                label={text("Phone")}
                value={guest ? guest.Phone || "" : ""}
                onChange={(e, { value }) => setPhone(value)}
              ></Form.Input>
              <Form.Field
                width="4"
                label={text("Nationality")}
                value={guest?.NationalityId}
                onChange={setNationality}
                clearable
                control={NationalitiesDropDown}
              />
            </Form.Group>
            <Form.Group widths="2">
              <Form.Field>
                <Form.Group unstackable className="date-pick-group">
                  <DatePicker
                    onChange={setCheckInDate}
                    label={text("Arrival")}
                    minDate={moment(businessDate).startOf("day").toDate()}
                    value={moment(
                      reservation?.CheckInDate || businessDate
                    ).toDate()}
                  />
                  <Form.Field
                    control={TimePicker}
                    label={text("ETA")}
                    style={{ minWidth: "unset" }}
                    width="6"
                    value={reservation?.Eta}
                    onChange={setEta}
                    disabled={
                      !isUserHasPermission(PermissionsActions.EditETA_ETD)
                    }
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <Form.Group unstackable className="date-pick-group">
                  <DatePicker
                    onChange={setCheckOutDate}
                    label={text("Departure")}
                    minDate={moment(reservation?.CheckInDate || businessDate)
                      .startOf("day")
                      .toDate()}
                    value={
                      reservation.CheckOutDate
                        ? moment(reservation.CheckOutDate)
                          .startOf('day')
                          .toDate()
                        : moment(businessDate)
                          .startOf('day')
                          .add(1, 'day')
                          .toDate()
                    }
                    pointing="right"
                  />
                  <Form.Field
                    control={TimePicker}
                    label={text("ETD")}
                    style={{ minWidth: "unset" }}
                    width="6"
                    value={reservation.Edt}
                    onChange={setEDT}
                    disabled={
                      !isUserHasPermission(PermissionsActions.EditETA_ETD)
                    }
                  />
                </Form.Group>
              </Form.Field>
            </Form.Group>
            <Form.Group widths={3} unstackable>
              <Form.Field
                label={text("Adults")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Adults)}
                min={0}
                onUserInteraction={() => { userChangedPaxRef.current = true; }}
                onKeyDown={() => { userChangedPaxRef.current = true; }}
                onChange={setAdults}
              />
              <Form.Field
                label={text("Children")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Children)}
                min={0}
                onUserInteraction={() => { userChangedPaxRef.current = true; }}
                onKeyDown={() => { userChangedPaxRef.current = true; }}
                onChange={setChildren}
              />
              <Form.Field
                label={text("Infants")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Infants)}
                min={0}
                onUserInteraction={() => { userChangedPaxRef.current = true; }}
                onKeyDown={() => { userChangedPaxRef.current = true; }}
                onChange={setInfants}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field
                width="9"
                label={text("RoomType")}
                required
                control={RoomTypesDropDown}
                spec={RoomTypesSpec}
                value={reservation.RoomTypeId}
                onChange={setRoomType}
                onValueNotFound={() => setRoomType(null)}
                disabled={roomFieldsDisabledByLock}
              />
              <Form.Field
                key={`room-${reservation.RoomId || 'empty'}`}
                width="7"
                label={
                  <label>
                    {text("Room")}
                    {canToggleRoomLock && (
                      <Icon
                        name={isRoomLocked ? "lock" : "lock open"}
                        color={isRoomLocked ? "red" : undefined}
                        style={{ cursor: "pointer", marginLeft: 6 }}
                        onClick={toggleDNC}
                        title={isRoomLocked ? text("LockedRoomTooltip") : text("UnlockedRoomTooltip")}
                      />
                    )}
                    {isRoomLocked && !canToggleRoomLock && (
                      <Icon name="lock" color="red" style={{ marginLeft: 6 }} title={text("LockedRoomTooltip")} />
                    )}
                  </label>
                }
                control={RoomsDropDown}
                spec={RoomsSpec}
                clearable
                value={reservation.RoomId}
                onChangeItem={setRoom}
                onValueNotFound={() => setRoom(null)}
                disabled={roomFieldsDisabledByLock}
              />
            </Form.Group>
            {!reservation.RoomId && (
              <Message warning visible>
                {text("NoRoomSelectedForReservation")}
              </Message>
            )}
            <Form.Group>
              <Form.Field
                width="9"
                control={ProductsDropDown}
                required
                key={`products-${reservation.Adults}-${reservation.Children}-${reservation.Infants}-${reservation.RoomTypeId}-${reservation.CheckInDate}-${reservation.CheckOutDate}`}
                label={text("Product")}
                spec={ProductsSpec}
                value={selectedProduct?.ProductKey || (reservation.ProductId + '-' + (reservation.PromotionId || ''))}
                descriptionField="RateName"
                valueField={"ProductKey"}
                labelField={productLabel}
                onChangeItem={setProductItem}
                initial={initialProductRef.current}
              />
              <Form.Field
                width="7"
                control={PricingTypesDropDown}
                label={text("ReservationPricingType_ComboTitle")}
                search={false}
                value={reservation.ReservationPricingTypeId}
                onChange={setPricingType}
                onValueNotFound={() => setPricingType(null)}
                disabled={
                  !isUserHasPermission(PermissionsActions.EditPricingType)
                }
              />
            </Form.Group>
            {commisionIncompatableCurrency() && (
              <Message visible>
                {text("ProductCurrencyIsDifferentFromCustomerCommisison")}
              </Message>
            )}
            <Form.Group widths="3">
              <Form.Field>
                <label>{text("DiscountPercent")}</label>
                <NumericInput
                  min={0}
                  max={100}
                  digits={0}
                  disabled={!isEditPriceAllowed()}
                  labelPosition='right'
                  value={discountPercent}
                  onChange={discountPercentChanged}
                />
              </Form.Field>
              <Form.Field>
                <label>{text("TotalPriceNotIncTax")}</label>
                <CurrencyInput
                  disabled={!isEditPriceAllowed()}
                  labelPosition='right'
                  currency={currencySymbol}
                  value={reservation.TotalAmountProductCurrentBeforeTax ?? reservation.TotalAmountDebitBeforeTax}
                  onChange={(value) => setTotalPrice(value, false)}
                />
              </Form.Field>
              <Form.Field>
                <label>{text("TotalPriceIncTax")}</label>
                <CurrencyInput
                  disabled={!isEditPriceAllowed()}
                  labelPosition='right'
                  currency={currencySymbol}
                  value={reservation.TotalAmountProductCurrentAfterTax ?? reservation.TotalAmountDebitAfterTax}
                  onChange={(value) => setTotalPrice(value, true)}
                />
              </Form.Field>
            </Form.Group>
            {reservationPolicyView}
          </Tab.Pane>
        ),
      },
      {
        menuItem: isMobileOnly
          ? { icon: "sticky note outline" }
          : text("OptionalDetails"),
        pane: (
          <Tab.Pane as={Form} key="optional">
            <Form.Group widths="3">
              <Form.Field
                control={CustomerDropDown}
                clearable
                spec={AgentsSpec}
                label={text("Agent")}
                value={reservation.AgentId}
                imageField={null}
                onChange={setAgent}
                onChangeItem={onChangeAgentItem}
                onValueNotFound={() => setAgent(null)}
              />
              <Form.Field
                control={CustomerDropDown}
                clearable
                spec={CompaniesSpec}
                label={text("Company")}
                value={reservation.CompanyId}
                imageField={null}
                onChange={setCompany}
                onChangeItem={onChangeCompanyItem}
                onValueNotFound={() => setCompany(null)}
              />
              <Form.Field
                control={ReservationSourcesDropDown}
                clearable
                label={text("ReservationSources")}
                value={
                  reservation.ReservationSourceId ||
                  reservation.ReservationSourceID
                }
                onChange={setReservationSource}
                onValueNotFound={() => setReservationSource(null)}
              />
            </Form.Group>
            {allocationFeature && (
              <Form.Group widths='3'>
                <Form.Field
                  control={DropDown}
                  clearable
                  label={text('Allocation')}
                  value={allocation}
                  onChange={(value) => {
                    // Guard: ignore onChange fired by the dropdown during initial data population
                    // (when the dropdown receives data and auto-matches the current value).
                    // Only treat it as a user change if the value actually differs from current allocation.
                    const newVal = value || 0;
                    if (newVal === allocation) return;
                    userChangedAllocationRef.current = true;
                    currentAllocationRef.current = newVal;
                    setAllocation(newVal);
                  }}
                  data={availableAllocations}
                  disabled={!mandatoryAllocationFieldsSupplied()}
                  textField="AllocationName"
                  valueField="AllocationId"
                  descriptionField={ad => ad.RoomTypesLeftRooms?.find(rtlr => rtlr.RoomTypeId === reservation.RoomTypeId)?.LeftRooms || ad.LeftRooms}
                />
              </Form.Group>
            )}
            {commisionIncompatableCurrency() && (
              <Message visible>
                {text("ProductCurrencyIsDifferentFromCustomerCommisison")}
              </Message>
            )}
            {agent && agent.ExternalChannelID && (
              <Form.Group widths="2">
                <Form.Input
                  required
                  label={text("ExternalReservationMasterID")}
                  value={reservation.ExternalReservationMasterId}
                  onChange={(e, { value }) => setExternalMasterID(value)}
                  error={
                    missingMasterId() ? text("ExternalIDIsMandatory") : null
                  }
                />
                <Form.Input
                  label={text("VoucherCode")}
                  value={reservation.VoucherNumber}
                  onChange={(e, { value }) => setVoucherNumber(value)}
                />
              </Form.Group>
            )}
            <Form.Field
              label={text("Comments")}
              control={HtmlEditor}
              defaultValue={reservation.Comments}
              onChange={setComments}
              style={{ height: "10em" }}
            />
            <Form.Field
              label={text("MessagesForGuests")}
              control={HtmlEditor}
              defaultValue={reservation.CommentsVisibleToGuest}
              onChange={setCommentsForGuest}
              style={{ height: "10em" }}
            />
          </Tab.Pane>
        ),
      },
    ];
    const hasCCFeature =
      reservationHotel?.HotelFeatures?.find((x) => x.FeatureId === HotelFeatureCodes.SelfieCreditCardInterface);

    if (hasCCFeature && digitalPermissions) {
      panes.push({
        menuItem: isMobileOnly ? { icon: "payment" } : text("PaymentMethods"),
        pane: (
          <Tab.Pane as={Form} key="payment">
            <PaymentDialog
              ref={paymentDialogRef}
              HotelId={reservation.HotelId}
              reservation={reservation}
              allowedPaymentProviderIDs={defaultAllowedPaymentProviderIDs}
              onIs3dsOpenChange={Is3dsOpenChange}
              minVal={0}
              amount={balance || reservation.TotalAmountProductCurrentAfterTax}
              readOnlyAmount={
                !isUserHasPermission(PermissionsActions.EditReceiptPrice)
              }
            ></PaymentDialog>
          </Tab.Pane>
        ),
      });
    }

    if (!_.isEmpty(reservation) && reservation.Id && reservation.HotelId && reservation.CheckInDate && reservation.CheckOutDate) {
      panes.push({
        menuItem: isMobileOnly
          ? { icon: "sticky note outline" }
          : text("ExtraAddons"),
        pane: (
          <Tab.Pane as={Form} key="extra-addons">

            <ExtraAddonsGrid
              reservation={reservation}
              data={reservation.ReservationDailyAddons || []}
              setData={setReservationDailyAddons}
              setDataForDeletion={setReservationDailyAddonsForDeletion}
              hotelId={reservation.HotelId}
              startDate={reservation.CheckInDate}
              endDate={reservation.CheckOutDate}
              rateId={rateId}
              insufficientAddon={insufficientAddon}
              setInsufficientAddon={setInsufficientAddon}
            />
          </Tab.Pane>
        ),
      })
    }

    return panes;
  }, [reservationHotel, reservation, guest, availableAllocations, allocation, allocationFeature, rateId, digitalPermissions, selectedProduct, reservationPolicyView]);

  return (
    <Modal
      {...rest}
      size="small"
      onClose={closeAction}
      closeOnDimmerClick={false}
      closeOnEscape={true}
    >
      <Modal.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {text("ShortReservation")}
        {clubMemeberFeature && (
          <ClubMemberIcon clubMemberDetails={clubMemberDetails} />
        )}
      </Modal.Header>
      <Modal.Content style={{
        minHeight: 620,
        maxHeight: 720,
        overflow: 'auto'
      }} className="shortReservation">
        <Tab
          renderActiveOnly={false}
          menu={{ secondary: true, pointing: true }}
          panes={panes}
        />
        {confirmNewGuestElement}
        {clubMemberPopup}
        <Confirm
          open={showRoomLockConfirm}
          className="centered-confirm"
          onConfirm={confirmDNCLock}
          onCancel={() => setShowRoomLockConfirm(false)}
          content={text("ConfirmLockRoom")}
          confirmButton={text("Confirm")}
          cancelButton={text("Cancel")}
        />
        <Confirm
          open={showRoomUnlockConfirm}
          onConfirm={confirmDNCUnlock}
          onCancel={() => setShowRoomUnlockConfirm(false)}
          content={text("ConfirmUnlockRoom")}
          confirmButton={text("Confirm")}
          cancelButton={text("Cancel")}
        />
        <ReservationPolicyUpdateConfirmationPopup
          open={showPolicyChangePopup}
          onKeepCurrentPolicy={() => setShowPolicyChangePopup(false)}
          onApplyNewPolicy={handleApplyNewPolicy}
          newPolicyDetails={newPolicyDetails}
        />
      </Modal.Content>
      {displaySave && <Modal.Actions>
        <Button disabled={isSaving} negative size='small' onClick={closeAction}>
          {' '}
          {text('Close')}
        </Button>
        <Button
          size="small"
          icon={isMobileOnly ? null : "external"}
          labelPosition={isMobileOnly ? null : "right"}
          onClick={fullReservation}
          content={text("Expand")}
        />
        <Button
          disabled={!isSaveEnabled}
          loading={isSaving}
          positive
          size="small"
          onClick={saveAction}
        >
          {text("Save")}
        </Button>
      </Modal.Actions>}
    </Modal>
  );
  /* eslint-enable react/display-name */
};

ShortReservationPopup.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  reservation: PropTypes.object,
  hotel: PropTypes.object,
};
export default ShortReservationPopup;
